/* src/app/pages/ortho/empresa/empresa.component.scss */
/*# sourceMappingURL=empresa.component.css.map */
